export let Algorithm = {
  algorithmId: '',
  hyperParams: [],
  optimizeParams: false
}

export let AlgorithmsCategory = {
  categoryId: '',
  categoryName: '',
  algorithms: []
}

export let AlgorithmSummary = {
  algorithmId: '',
  algorithmName: '',
  description: {
    text: '',
    imgUrl: ''
  },
  enabled: Boolean,
  hyperParams: [],
  category: AlgorithmsCategory
}



// WEBPACK FOOTER //
// ./src/defines/algorithm.js